<template lang="">
<div class="modal">
        <a  class="modal_close" @click="$emit('close')"></a>
        <div class="modal_header">
            <div class="title">간편로그인 미 연결 안내</div>
            <p class="txt">해당 계정으로 간편 로그인 설정이 되어 있지 않습니다.</p>
        </div>
        <div class="modal_body">
            <div class="easyLogin_txt">
                회원가입 또는 일반회원 로그인 후, <br>
                <span>마이페이지 > 정보관리 > SNS연결설정</span> 페이지에서 <br>
                간편 로그인 연결 설정을 해 주세요.
            </div>
            <div class="easyLogin_btn">
                <button type="button" class="btn_connect">간편로그인 연결</button>
                <button type="button" class="btn_join">블러썸로고스 회원가입</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>